import { createFileRoute } from '@tanstack/react-router';
import { Breadcrumbs } from '@components/navigation/Breadcrumb.tsx';
import SupplierLayout from '@components/layout/supplier/SupplierLayout.tsx';
import SupplierOrderList from '@features/supplier/orders/SupplierOrderList.tsx';
import { z } from 'zod';
import { useSupplierOrderStore } from '@features/supplier/orders/supplierOrderStore.ts';
import { OrderStatus } from '@api/generated/search-service';
import { useTranslation } from 'react-i18next';

const supplierOrdersSearchSchema = z.object({
  query: z.string().optional(),
  customerId: z.coerce.number().optional(),
  orderStatus: z.nativeEnum(OrderStatus).optional(),
  deliveryFrom: z.string().optional(),
  deliveryTo: z.string().optional(),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
});

export type SupplierOrdersSearch = z.infer<typeof supplierOrdersSearchSchema>;

export const Route = createFileRoute('/s/$orgId/$portalId/orders/')({
  validateSearch: search => supplierOrdersSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    useSupplierOrderStore.getState().fetchOrders({
      query: ctx.search.query,
      organizationId: ctx.search.customerId,
      orderStatus: ctx.search.orderStatus,
      deliveryDateFrom: ctx.search.deliveryFrom,
      deliveryDateTo: ctx.search.deliveryTo,
      page: ctx.search.page || 1,
      size: ctx.search.size,
    });
  },
});

function RouteComponent() {
  const { t } = useTranslation('client');
  return (
    <SupplierLayout>
      <div className="mb-8">
        <Breadcrumbs items={[{ label: t('supplierOrders.breadcrumb'), href: undefined }]} />
        <div className="flex items-center justify-between mb-2 mt-4">
          <h1 className="text-3xl font-bold text-main">{t('supplierOrders.pageTitle')}</h1>
        </div>
        <p className="text-light">{t('supplierOrders.pageDescription')}</p>
      </div>

      <SupplierOrderList />
    </SupplierLayout>
  );
}
